var exports = {
  "kL": "x04b3a21e--999a94--container",
  "Qs": "x04b3a21e--999a94--content",
  "q9": "x04b3a21e--999a94--price",
  "FI": "x04b3a21e--999a94--parameters",
};

module.exports = exports;
